import { useState, useRef, forwardRef, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { pt } from "date-fns/locale/pt";
import "react-datepicker/dist/react-datepicker.css";
import useStore from "../../store/useStore";
registerLocale("pt", pt);

interface CustomInputProps {
  value?: string;
  onClick?: () => void;
  className?: string;
}

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ value, onClick, className }, ref) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      ref={ref}
      className={className}
    />
  )
);

export default function SelectDateGetDataEmployee() {
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const datePickerRef = useRef<DatePicker>(null);
  const { setTrackingDate } = useStore((state) => state);
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    if (selectedDate) {
      setTrackingDate(selectedDate);
    }
  }, [selectedDate, setTrackingDate]);

  return (
    <div className=" bg-gray-50 dark:bg-gray-350 rounded-lg h-full flex flex-col overflow-visible">
      <div className=" bg-gray-100 dark:bg-gray-400 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md font-semibold text-sm">        Colaboradores
        Selecionar data
      </div>
      <div className="w-full flex-grow flex flex-col justify-center px-1">
        <div className="w-full">
          <DatePicker
            ref={datePickerRef}
            selected={selectedDate}
            onChange={handleDateChange}
            locale="pt"
            dateFormat="dd/MM/yyyy"
            maxDate={new Date()}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={15}
            placeholderText="Selecione uma data"
            popperClassName="date-picker-popper"
            wrapperClassName="w-full"
            customInput={
              <CustomInput 
              className="h-[26px] w-full text-center p-2 rounded-md
                text-black border-gray-300 bg-gray-50
                focus:outline-none
                focus:border-transparent"
                />
            }
          />
        </div>
      </div>
    </div>
  );
}
